<div class="page-wrapper">
  <div class="w-full py-4 block sm:hidden">
    <go-back></go-back>
  </div>
  <div class="title mb-6 sm:mb-6 lg:mb-8">
    <h1 class="font-bold">{{ 'okeeyCash.yourDocumentation' | translate }}</h1>
  </div>
  <div class="subtitle mb-8 sm:mb-8 lg:mb-12">
    <span>{{ 'okeeyCash.transparentCardholderFees' | translate }}</span>
  </div>
  <div class="image-wrapper mb-8 sm:mb-8 lg:mb-12">
    <img class="image" src="../../../../../assets/img/my-okeey-cash/your-documentation.svg" />
    <img class="image-mobile" src="../../../../../assets/img/my-okeey-cash/your-documentation-mobile.svg" />
  </div>
  <div class="description mb-8 sm:mb-8 lg:mb-12">
    <span>
      {{ 'okeeyCash.wereCommittedToOffering' | translate }}
      <span class="description-bold">{{ 'okeeyCash.noMonthlyFees' | translate }}</span>
    </span>
    <br />
    <br />
    <span>{{ 'okeeyCash.belowIsAComprehensive' | translate }}</span>
  </div>
  <div class="fees-list mb-4 sm:mb-4 lg:mb-6">
    <nz-collapse>
      @for (item of feesList; track item) {
        <nz-collapse-panel [nzHeader]="item.localizableTitle | translate" [nzActive]="false">
          <nz-table #basicTable class="fees-table" [nzData]="item.fees" nzBordered nzHideOnSinglePage>
            <thead>
              <tr>
                <th>{{ 'okeeyCash.fees' | translate }}</th>
                <th>{{ 'okeeyCash.amount' | translate }}</th>
                <th class="hidden-for-mobile">{{ 'okeeyCash.description' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (fee of basicTable.data; track fee) {
                <tr>
                  <td class="fee-row fee-row-name">{{ fee.localizableName | translate }}</td>
                  <td class="fee-row fee-row-amount">{{ fee.amount | currency }}</td>
                  <td
                    class="fee-row fee-row-description hidden-for-mobile"
                    [innerHTML]="fee.localizableDescription | translate | linkify"
                  ></td>
                </tr>
              }
            </tbody>
          </nz-table>
        </nz-collapse-panel>
      }
    </nz-collapse>
  </div>
  <div class="for-details mb-10">
    <span>
      {{ 'okeeyCash.forFurtherDetails' | translate }}
      <a (click)="onOkeeyCashWebsiteClick()">{{ 'okeeyCash.okeeyCash' | translate }}</a>
      {{ 'okeeyCash.websiteOurAim' | translate }}
    </span>
  </div>
  <div class="cardholder-agreement">
    @for (item of [0, 1]; track item) {
      <div class="cardholder-agreement-item" (click)="onCardHolderAgreementClick(item ? 'en' : 'es')">
        <span
          >{{ 'okeeyCash.cardHolderAgreement' | translate }}
          <span class="lang">{{ (item ? 'okeeyCash.english' : 'okeeyCash.spanish') | translate }}</span></span
        >
        <button nz-button nzType="text" (click)="onCardHolderAgreementClick(item ? 'en' : 'es')">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M5.20827 4.25C4.40287 4.25 3.74997 4.90292 3.74997 5.70833V15.2917C3.74997 16.0971 4.40287 16.75 5.20827 16.75H14.7913C15.5967 16.75 16.2497 16.0971 16.2497 15.2917V11.9583C16.2497 11.6132 16.5295 11.3333 16.8747 11.3333C17.2198 11.3333 17.4996 11.6132 17.4996 11.9583V15.2917C17.4996 16.7874 16.2871 18 14.7913 18H5.20827C3.71253 18 2.5 16.7874 2.5 15.2917V5.70833C2.5 4.21256 3.71253 3 5.20827 3H8.5415C8.88667 3 9.1665 3.27983 9.1665 3.625C9.1665 3.97017 8.88667 4.25 8.5415 4.25H5.20827ZM10.8331 3.625C10.8331 3.27983 11.1129 3 11.4581 3H16.875C17.2202 3 17.5 3.27983 17.5 3.625V9.04167C17.5 9.38683 17.2202 9.66667 16.875 9.66667C16.5298 9.66667 16.25 9.38683 16.25 9.04167V5.13395L11.9 9.48367C11.6559 9.72767 11.2603 9.72767 11.0162 9.48358C10.7721 9.2395 10.7721 8.84375 11.0162 8.5997L15.3663 4.25H11.4581C11.1129 4.25 10.8331 3.97017 10.8331 3.625Z"
                fill="#737980"
              />
            </svg>
          </i>
        </button>
      </div>
    }
  </div>
</div>
